export const CONTROLE_MODE_OPTIONS = [
    { value: "", label: "— Non défini —" },
    { value: "NETSOIN", label: "Netsoin" },
    { value: "TITAN", label: "Titan" },
    { value: "DOMINLIK_IMAGO", label: "Dominlik et Imago" },
    { value: "SANS_LOGICIEL", label: "Sans logiciel" },
];

export function controleModeLabel(value) {
    return CONTROLE_MODE_OPTIONS.find(option => option.value === value)?.label || "—";
}

export function normalizeProductionSubcategory(value) {
    return String(value || "").trim();
}

export function addProductionSubcategory(values, value) {
    const normalized = normalizeProductionSubcategory(value);
    if (!normalized) return values;
    return values.some(item => item.toLowerCase() === normalized.toLowerCase())
        ? values
        : [...values, normalized];
}

export function removeProductionSubcategory(values, value) {
    return values.filter(item => item !== value);
}

export function emptyEhpadForm(color) {
    return {
        code: "",
        nom: "",
        address: "",
        phone: "",
        tourneeId: "",
        color,
        controleMode: "",
        productionSubcategories: [],
        productionSubcategoryDraft: "",
        inviteEmail: "",
    };
}
